<template>
  <div class="crm-main-section DealsSection">
    <div class="d-flex justify-content-between align-items-center w-100 mb-5">
      <h2 class="crm-main-section-heading text-case-unset mb-0">
        Company Fields
        <b-icon icon="info-circle-fill" class="cursor_pointer infoKbIcon sm-mar-left" />
      </h2>
      <button class="crm-button">
        <vb-icon class="crm-plusButton-icon" icon="crm-plusButton-icon" />
        Add New
      </button>
    </div>
    <div class="crm-card p-32">
      <h2 class="crm-main-section-heading text-case-unset my-0" style="color:black;">
        Detail Fields
      </h2>
      <div class="d-flex justify-content-between align-items-center w-100 mt-2">
        <p class="crm-card-text my-0">
          Fields that are available and will be displayed on records detail.
        </p>
        <button class="crm-button">
          Manage Fields
        </button>
      </div>
    </div>
    <div class="crm-card p-32">
      <h2 class="crm-main-section-heading text-case-unset my-0" style="color:black;">
        Creation Fields
      </h2>
      <div class="d-flex justify-content-between align-items-center w-100 mt-2">
        <p class="crm-card-text my-0">
          Fields that will be displayed when any user creates a record.
        </p>
        <button class="crm-button">
          Manage Fields
        </button>
      </div>
    </div>
    <div class="crm-card p-32">
      <h2 class="crm-main-section-heading text-case-unset my-0" style="color:black;">
        Edit / Preview Fields
      </h2>
      <div class="d-flex justify-content-between align-items-center w-100 mt-2">
        <p class="crm-card-text my-0">
          Fields that are available and will be displayed on record edit/preview view.
        </p>
        <button class="crm-button">
          Manage Fields
        </button>
      </div>
    </div>
    <div class="crm-card p-32">
      <h2 class="crm-main-section-heading text-case-unset my-0" style="color:black;">
        List Fields
      </h2>
      <div class="d-flex justify-content-between align-items-center w-100 mt-2">
        <p class="crm-card-text my-0">
          To adjust the fields that are displayed on the list view, when viewing the Companies list, click the  icon located at the navigation bar and choose 
          "List settings".
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CompanyFields',
  components: {
    
  },
  inject:['isEmpty'],
  data(){
    return {
      tableData : {
        0: {m1: '123',m2 : '123',m3 : '123',m4 : '123',m5 : '123',chk:false},
        1: {m1: '123',m2 : '123',m3 : '123',m4 : '123',m5 : '123',chk:true},
        2: {m1: '123',m2 : '123',m3 : '123',m4 : '123',m5 : '123',chk:false},
        3: {m1: '123',m2 : '123',m3 : '123',m4 : '123',m5 : '123',chk:true},
        4: {m1: '123',m2 : '123',m3 : '123',m4 : '123',m5 : '123',chk:false},
        5: {m1: '123',m2 : '123',m3 : '123',m4 : '123',m5 : '123',chk:true},
        6: {m1: '123',m2 : '123',m3 : '123',m4 : '123',m5 : '123',chk:false},
        7: {m1: '123',m2 : '123',m3 : '123',m4 : '123',m5 : '123',chk:true},
        8: {m1: '123',m2 : '123',m3 : '123',m4 : '123',m5 : '123',chk:false},
        9: {m1: '123',m2 : '123',m3 : '123',m4 : '123',m5 : '123',chk:true},
        10: {m1: '123',m2 : '123',m3 : '123',m4 : '123',m5 : '123',chk:false},
      },
      allowedUploadfileExtentions: 'jpg, jpeg, png, gif, svg, pdf, aac, ogg, oga, mp3, wav, mp4, m4v, mov, ogv, webm, zip, rar, doc, docx, txt, text, xml, json, xls, xlsx, odt, csv, ppt, pptx, ppsx, ics, eml'
    }
  },
  computed: {
    
  },
  methods: {
    
  },
  mounted(){
    
  },
}
</script>

<style>

</style>